import { EntityState } from '@ngrx/entity';
import { Filter } from '@shared/models/filter';
import { Interest } from '@shared/models/interest';
import { PreferencesAction, PreferencesActionTypes, TogglePreferenceAction } from '../actions';
import { primaryInterestAdapter } from '../adapters/primary-interest.adapter';

export interface PrimaryInterestState extends EntityState<Interest> {
  loading: boolean;
  nextPage: boolean;
  nextPageIndex?: number;
  searchPhrase: string;
  initialFilter: string;
  selectedFilter: Array<Filter>;
}

export const initialPrimaryInterestsState: PrimaryInterestState = primaryInterestAdapter.getInitialState({
  loading: true,
  nextPage: false,
  nextPageIndex: null,
  searchPhrase: '',
  initialFilter: '',
  selectedFilter: [],
});

export function primaryInterestReducer(
  state: PrimaryInterestState = initialPrimaryInterestsState,
  action: PreferencesAction | TogglePreferenceAction
): PrimaryInterestState {
  switch (action.type) {
    case PreferencesActionTypes.LOAD_PRIMARY_INTERESTS: {
      return {
        ...initialPrimaryInterestsState,
      };
    }

    case PreferencesActionTypes.LOAD_PRIMARY_INTERESTS_NEXT_PAGE: {
      return {
        ...state,
        loading: true,
      };
    }

    case PreferencesActionTypes.LOAD_PRIMARY_INTERESTS_SUCCESS: {
      const newPrimaryInterestsState: PrimaryInterestState = {
        ...state,
        loading: false,
        nextPage: action.payload.nextPage,
        nextPageIndex: action.payload.nextPage ? action.payload.nextPageIndex : null,
      };

      return primaryInterestAdapter.addMany(action.payload.primaryInterests, newPrimaryInterestsState);
    }

    case PreferencesActionTypes.LOAD_PRIMARY_INTERESTS_FAILURE: {
      return {
        ...state,
        loading: false,
      };
    }

    case PreferencesActionTypes.PRIMARY_INTERESTS_SEARCH_TERM_CHANGE: {
      return primaryInterestAdapter.removeAll({
        ...state,
        loading: true,
        nextPage: false,
        searchPhrase: action.payload.searchPhrase,
      });
    }

    case PreferencesActionTypes.TOGGLE_PREFERENCE: {
      const updatedState = JSON.parse(JSON.stringify(state));

      for (const key in updatedState.entities) {
        const value = updatedState.entities[key];
        if (value.id === +action.id) {
          value.is_preferred = !value?.is_preferred;
        }
      }
      return {
        ...updatedState,
      };
    }

    case PreferencesActionTypes.PRIMARY_INTERESTS_CATEGORY_FILTER: {
      return primaryInterestAdapter.removeAll({
        ...state,
        loading: true,
        nextPage: false,
        selectedFilter: action.payload.selectedFilters,
      });
    }

    default:
      return state;
  }
}
